/* eslint-disable @angular-eslint/no-host-metadata-property */
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Dropdown, IAssignVendorSalesRep } from '@telus/d2c-core';
import { Observable, BehaviorSubject } from 'rxjs';

@Component({
  selector: 'telus-assign-vendor-sales-rep',
  templateUrl: 'telus-assign-vendor-sales-rep-modal.component.html',
  styles: [
    '::ng-deep telus-assign-vendor-sales-rep { justify-content: normal !important; }',
  ],
  // eslint-disable-next-line @typescript-eslint/naming-convention
  host: { '[class.d-flex]': 'true' },
})
export class TelusAssignVendorSalesRepModalComponent implements OnInit {
  @Input() dataSource: Observable<Dropdown[]>;
  @Input() pageType;

  public dropdownData$ = new BehaviorSubject<Dropdown[]>([]);
  public dataConfig: IAssignVendorSalesRep;

  constructor(public modalCtrl: ModalController) {}

  ngOnInit() {
    /** Mapping data for sales rep modal dropdown. **/
    if (this.dataSource) {
      this.dataSource.subscribe((dropdownItems: Dropdown[]) => {
        this.dropdownData$.next(dropdownItems);
      });
    }
  }

  /**
   * @Method onDropdownSelection
   * @Params item:  selected dropdown object.
   * @Description:  will be called on select sales repo value from dropdown.
   **/
  onDropdownSelection(item: Dropdown) {
    this.dataConfig = {
      ...this.dataConfig,
      value: item.value,
      label: item.text,
    };
  }

  /**
   * @Method closeModal
   * @Description: Close existing modal.
   **/
  closeModal() {
    this.modalCtrl.dismiss(null);
  }

  /**
   * @Method applyChanges
   * @Description: Save changes and return data with modal callback.
   **/
  applyChanges() {
    this.modalCtrl.dismiss(this.dataConfig);
  }
}
